module.exports = __webpack_public_path__ + "img/1.a99bff52.png";